import { StyleProps } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';

import { Text } from '@bonusly/ds-typography';

import { useDropdownContext } from '../lib/context';

export interface DropdownPlaceholderProps extends StyleProps, PropsWithChildren {
	value: any;
}

export const DropdownPlaceholder: FC = () => {
	const { placeholder } = useDropdownContext();

	if (typeof placeholder === 'string') {
		return (
			<Text color="gray.400" fontSize="md">
				{placeholder}
			</Text>
		);
	}

	return <>{placeholder}</>;
};
